// Get consolidated parameter which lists location handles if we want to filter
// the list we're grabbing the closest location from to a subset of all locations
const urlParams = new URLSearchParams(window.location.search);
const consolidatedParam = urlParams.get('consolidate')?.split(",");

//delete consolidate param so we can use the rest in the new url later, and add consolidated (added a d)
//urlParams.delete("consolidate");


// If filtering list to a subset, filter it, double check subset has at least one 
// item and assign our coordinates array to the filtered list
if (consolidatedParam) {
    let consolidatedCoordinates = allCoordinates.filter(coord => {
        return consolidatedParam.includes(coord.handle)
    })

    if (consolidatedCoordinates.length != 0) {
        allCoordinates = consolidatedCoordinates;
    }
}

// Function used to load fallback map
function fallbackMap() {
    let mapTemplate = document.querySelector("template#Store-by-geolocation-map-template");

    // Create a temporary container to hold the template HTML
    const temp = document.createElement("div");
    temp.innerHTML = mapTemplate.innerHTML.trim();

    // Insert the rendered fallback map before the template
    mapTemplate.insertAdjacentElement("beforebegin", temp.firstElementChild);

    const scriptFromTemplate = mapTemplate.content.querySelector("script");
    if (scriptFromTemplate) {
        const newScript = document.createElement("script");
        newScript.src = scriptFromTemplate.src;
        newScript.async = true;
        document.head.appendChild(newScript);
    }
}

// Function used to find distance between to locations
function distance(lat1, lon1, lat2, lon2, unit) {
    var radlat1 = Math.PI * lat1/180
    var radlat2 = Math.PI * lat2/180
    var theta = lon1-lon2
    var radtheta = Math.PI * theta/180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
        dist = 1;
    }
    dist = Math.acos(dist)
    dist = dist * 180/Math.PI
    dist = dist * 60 * 1.1515
    if (unit=="K") { dist = dist * 1.609344 }
    if (unit=="N") { dist = dist * 0.8684 }
    return dist
}

if (locationPromise) {
    locationPromise.then(() => {
        let userLocation = JSON.parse(window.sessionStorage.getItem("userLocation"));
        displayClosestLandingPage(userLocation.lat, userLocation.lon);

    }).catch((error) => {
        console.error('myInitCode encountered an error:', error);
    });
} else {
    // Fetch users current location
    fetch('https://ipapi.co/json/?key=XJ1dWf0FbzAbuK9XNVO53JxZSh0rWoKoSTWIqcMhQBFfCZgAVD')
    .then(function(response) {
        return response.json();
    })
    .then(function(data) {
        displayClosestLandingPage(data.latitude, data.longitude);
    })
    .catch((e) => {
        console.log("catch", e);
        fallbackMap();
    });
}


function displayClosestLandingPage(lat, lon) {
    if (lat && lon){

        // Declare buffer variable to be used in calculations
        let storeDistance = 0;

        // Assign closest store to first location in coordinates array as default, and remove it from array
        let closestStore = { 
            distance: distance(lat, lon, allCoordinates[0].lat, allCoordinates[0].lng),
            rel_url: allCoordinates[0].rel_url
        };
        allCoordinates.shift();

        // If another location is closer, save it as closest store
        allCoordinates.forEach((store) => {
            storeDistance = distance(lat, lon, store.lat, store.lng);
            if (storeDistance < closestStore.distance) {
                closestStore = { 
                    distance: storeDistance,
                    rel_url: store.rel_url
                };
            }
        })

        // reload page with closest store
        window.location.href = closestStore.rel_url + '?' + urlParams.toString();
    
    } else {
        fallbackMap();
    }
}